import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { LeveragedTokenToggleComponent } from "./leveraged-token-toggle.component";

@NgModule({
	declarations: [LeveragedTokenToggleComponent],
	imports: [CoreModule],
	exports: [LeveragedTokenToggleComponent]
})
export class LeveragedTokenToggleModule {}
